/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>模板设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="float: right;margin-right:2%;">
      <!-- <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary"
            icon="document" @click="dataSelect">刷新</el-button> -->
      <el-button style='margin: 10px 0;' size="mini" type="primary" icon="document" @click="addNotice">新增</el-button>
      <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document"><el-upload class="avatar-uploader" v-model="img"
             action="https://admin.shengqianxiong.com.cn/tao/upload" :show-file-list="false"
             :on-success="handleAvatarSuccess">新增</el-upload></el-button> -->
      <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
    </div>

    <el-table :tree-props="{ children: 'categories' }" style="width:100%" border v-loading="tableDataLoading"
      :data="tableData" row-key="id" @selection-change="handleSelectionChange">
      <!-- <el-table-column  prop="id" label="编号" width="80">
        </el-table-column> -->
      <el-table-column align="center" prop="name" label="名称">
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 0" effect="dark">
            分类
          </el-tag>
          <el-tag v-if="scope.row.type === 1" type="success" effect="dark">
            队伍
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="sort" label="排序">
      </el-table-column>
      <!-- <el-table-column width="150px" prop="createTime"  label="创建时间">
        </el-table-column> -->

      <el-table-column align="center" label="操作" width="240px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.type === 0" type="primary" icon="el-icon-plus" circle @click="openDw(scope.row)">
          </el-button>
          <el-button v-if="scope.row.type === 0" type="primary" icon="el-icon-edit" circle
            @click="updates(scope.$index, scope.row)">
          </el-button>
          <el-button type="danger" icon="el-icon-delete" circle @click="deletes(scope.row.id)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="分类增加" :visible.sync="dialogFormVisible" center>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">分类名称：</span>
        <el-input style="width:50%;" v-model="addForm.name" placeholder="输入分类名称"></el-input>
      </div>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">分类排序：</span>
        <el-input-number v-model="addForm.sort" :min="0" label="描述文字"></el-input-number>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="releasNoticeTo()">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分类修改" :visible.sync="dialogFormVisible1" center>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">分类名称：</span>
        <el-input style="width:50%;" v-model="updateForm.name" placeholder="输入分类名称"></el-input>
      </div>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">分类排序：</span>
        <el-input-number v-model="updateForm.sort" :min="0" label="描述文字"></el-input-number>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="updateUpTo()">修 改</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择队伍" :visible.sync="dialogFormVisible2" center>
      <div style="margin-right:2%;">
        <el-input style="width: 300px;" size="small" v-model="outlet" placeholder="请输入搜索内容"></el-input>
        <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary" icon="document"
          @click="dRdataSelect">确定</el-button>
      </div>
      <el-table v-loading="tableDataLoading2" ref="multipleTable2" :data="tableData2" tooltip-effect="dark"
        style="width: 100%" row-key="id" @selection-change="handleSelectionChange2">
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column align="center" label="网点名称" prop="outlet">
        </el-table-column>
        <el-table-column align="center" label="业务名称" prop="business">
        </el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="console2()">console</el-button> -->
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="addDRTo()">添 加</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { addCategory, deleteCategory, getCategoryList, updateCategory, getHotTeamList, addCategoryTeam } from '../../../api/manage/category.js'

import moment from 'moment';

export default {
  data() {
    return {
      outlet: '',
      categoryId: 0,
      multipleSelection: [],
      multipleSelection2: [],
      totalnum: 0,
      page: 1,
      size: 10,
      page2: 1,
      size2: 10,
      tableDataLoading: false,
      tableDataLoading2: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      tableData: [],
      tableData2: [],
      totalnum2: 0,
      addForm: {
        id:'',
        name: '',
        sort: '',
        type: '',
        teamId:'',
        categoryId:'',
        createTime:'',
        updateTime:''
      },
      updateForm: {
        id:'',
        name: '',
        sort: '',
        type: '',
        teamId:'',
        categoryId:'',
        createTime:'',
        updateTime:''
      },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    addDRTo() {
      // let a = this.$refs.multipleTable2;
      let selectedIds = this.multipleSelection2.map(item => item.id)
      let teamIds = selectedIds.join(',')
      let categoryId = this.categoryId
      // console.log('222',zz)
      let post = {
        categoryId: this.categoryId,
        teamIds: teamIds,
        type: 1
      }
      addCategoryTeam(post).then((res) => {
        this.dialogFormVisible3 = false
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
          onClose: () => {
            this.dataSelect()
          }
        });
      })
    },
    openDw(row) {
      this.categoryId = row.id
      // console.log('this.categoryId',this.categoryId)
      this.dialogFormVisible2 = true
      this.dRdataSelect()
    },
    handleSelectionChange(val) {
      console.log("val", val)
      this.multipleSelection = val;
    },

    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    releasNoticeTo() {
      let post = this.addForm;
      addCategory(post).then((res) => {
        this.dialogFormVisible = false
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
          onClose: () => {
            this.dataSelect()
          }
        });
      })

    },

    updateUpTo() {
      // let post = this.updateForm;
      let post = {
        id:this.updateForm.id,
        name:this.updateForm.name,
        sort:this.updateForm.sort
      }
      console.log("11111111111111111111111")
      console.log(post)
      updateCategory(post).then((res) => {
        this.dialogFormVisible1 = false
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        }
        // this.$message({
        //   type: "info",
        //   message: res.msg,
        // });
      })
    },

    updates(index, row) {
      this.updateForm = JSON.parse(JSON.stringify(row));
      
      this.dialogFormVisible1 = true
    },

    deletes(id) {
      let obj = {
        id: id,
      }
      this.$confirm(`确定删除此条信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCategory(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => { })
    },

    dataSelect() {
      let post = {
        page: (this.page - 1) * this.size,
        size: this.size
      }
      this.tableDataLoading = true
      getCategoryList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
          this.tableData = res.data.list
          this.totalnum = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })
    },

    dRdataSelect() {
      let post = {
        page: (this.page2 - 1) * this.size2,
        size: this.size2,
        outlet: this.outlet
      }
      this.tableDataLoading2 = true
      getHotTeamList(post).then((res) => {
        this.tableDataLoading2 = false
        if (res.code == 200) {
          console.log("Data2", res)
          this.tableData2 = res.data.list
          this.totalnum2 = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })
    },

    // 添加分类弹框
    addNotice() {
      this.addForm = {
        name: '',
        sort: 1,
        type: 0
      },
        this.dialogFormVisible = true
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/category/index.vue